export function allMatcherContext() {
    return function allMatcher(runtimeAttr) {
        return runtimeAttr != null;
    };
}
